var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxForm',{attrs:{"id":"floorForm","caption":"Floor Form"}},[_c('DxGroupItem',{attrs:{"caption":_vm.$t('DxFloor_DxGroupItem_caption'),"col-count":"3"}},[_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('DxFloor_DxSimpleItem_floorSelector_dataField'),"editor-options":{
        items: _vm.floorOptions,
        searchEnabled: true,
        searchTimeout: _vm.searchTimeoutOption,
        minSearchLength: _vm.minSearchLengthOption,
        showDataBeforeSearch: _vm.showDataBeforeSearchOption,
        onValueChanged: _vm.floorValueChanged,
        value: _vm.initialFloor,
      },"editor-type":"dxSelectBox","name":"floorSelector"}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Required_message')}})],1),_vm._v(" "),_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('DxFloor_DxColumn_UsefulLife_caption'),"name":"usefulLife","caption":_vm.$t('DxFloor_DxColumn_UsefulLife_caption'),"editor-options":{
        value: _vm.initialUsefulLife,
        showSpinButtons: true,
        placeholder: '0',
        showClearButton: true,
        min: '0',
        max: 100,
        step: '0.5',
        onValueChanged: _vm.usefulLifeChanged,
      },"editor-type":"dxNumberBox"}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Required_message')}})],1),_vm._v(" "),_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('DxFloor_DxColumn_PercentageOfStoniness_caption'),"name":"percentageOfStoniness","caption":_vm.$t('DxFloor_DxColumn_PercentageOfStoniness_caption'),"editor-options":{
        value: _vm.initialPercentageOfStoniness,
        showSpinButtons: true,
        placeholder: '0',
        showClearButton: true,
        min: '0',
        max: 100,
        step: '1',
        onValueChanged: _vm.percentageOfStoninessChanged,
      },"editor-type":"dxNumberBox"}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Required_message')}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }